import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-room",
  "use": "icon-room-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-room\"><path d=\"M425.984 470.016v84.01H512v-84.01h-86.016zM598.016 256v640H128v-86.016h86.016V128h384v41.984h212.01v640h86.017V896H726.059V256h-128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol